<template>
  <SelectComponent
    v-model="selectedValues"
    :values="orderedPaymentsModes"
    :label="label || $t('attributes.payment_mode')"
    :required="required"
    name="payment_mode"
    :errors="errors"
    :edition-mode="editionMode"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import { computed } from 'vue'
import SelectComponent from '@c/BaseFormComponent/SelectComponent'

export default {
  name: 'SelectPaymentModes',
  components: { SelectComponent },
  props: {
    editionMode: {
      type: Boolean,
      required: true
    },
    errors: {
      type: Array,
      required: false,
      default: () => []
    },
    modelValue: {
      type: [Array, Number],
      required: true
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const selectedValues = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value)
    })
    return { selectedValues }
  },
  computed: {
    ...mapGetters('metadata', {
      paymentsModes: 'getPaymentModesMetadata'
    }),
    orderedPaymentsModes() {
      return this.paymentsModes.sort((a, b) => a.name.localeCompare(b.name))
    }
  }
}
</script>
